// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"b3d5e268","125":"38e20ae1","289":"da0103d8","538":"968bd7f8","673":"06c4dbb7"}[chunkId] + ".js";
};